import { Controller } from "stimulus";

export default class extends Controller {
  toggle(event) {
    const button = event.currentTarget;
    button.disabled = true;
    const id = button.dataset.exceptionId;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token) headers["X-CSRF-Token"] = token.getAttribute("content");

    fetch(`/admin/exception_messages/${id}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify({ toggle_incorrect: true }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          if (data.incorrect) {
            button.classList.remove("btn-danger");
            button.classList.add("btn-success");
            button.textContent = "Revert Incorrect";
          } else {
            button.classList.remove("btn-success");
            button.classList.add("btn-danger");
            button.textContent = "Report as Incorrect";
          }
          this.showFlash("success", "Exception has been updated successfully.");
        } else {
          this.showFlash("danger", "Failed to update exception.");
        }
      })
      .catch((error) => {
        this.showFlash("danger", error);
      })
      .finally(() => {
        button.disabled = false;
      });
  }

  showFlash(type, message) {
    const flashesContainer = document.querySelector(".alert-container .flashes");
    if (!flashesContainer) return;
    const flashElement = document.createElement("div");
    flashElement.className = `alert alert-${type}`;
    flashElement.setAttribute("role", "alert");
    flashElement.innerHTML = `
      ${message}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    `;
    flashesContainer.appendChild(flashElement);
  }
}
